import { FREE_PLAN_INVOICES_LIMIT_PER_MONTH } from 'shared/constants/invoices/limits';

import { useIsPremiumFeatureAvailable } from './useIsPremiumFeatureAvailable';

export const useMonthlyInvoicesLimit = (monthlyInvoicesCount: number) => {
    const { isPremiumFeatureAvailable } = useIsPremiumFeatureAvailable();

    return {
        isInvoiceLimitReached: isPremiumFeatureAvailable
            ? false
            : monthlyInvoicesCount >= FREE_PLAN_INVOICES_LIMIT_PER_MONTH,
    };
};
